<div class="public-schedule">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="publicForm">
          <form [formGroup]="publicScheduleForm" (ngSubmit)="onSubmit(publicScheduleForm)">
            <div class="button-group">
              <button mat-raised-button class="btn-warn" color="" (click)="back()">{{'test.createSchedule.btnBack' | translate}}</button>
              <button mat-raised-button class="btn-primary" color=""
                [disabled]="publicScheduleForm.status=='INVALID'? true: false || ((chipSelectedExaminee.length === 0 && !isParameterVisible) ? true: false ) || isEndTimeValid || isStartTimeValid"
                type="submit">{{'test.createSchedule.btnSave' | translate}}</button>
            </div>
            <div class="form-group ptb-padding">
              <label for="Schedule name">{{'test.createSchedule.public.labelName' | translate}}<span class="red-asterisk">*</span></label>
              <input type="text" autocomplete="off" class="form-control" id="schName" aria-describedby="scheduleName" maxlength="121"
                formControlName="schName">
              <div *ngIf="f.schName.invalid && (f.schName.dirty || f.schName.touched )">
                <div *ngIf="f.schName.errors?.required" class="alert alert-danger">
                  {{'test.createSchedule.public.nameError1' | translate}}</div>
                <div *ngIf="f.schName.errors?.minlength" class="alert alert-danger">
                  {{'test.createSchedule.public.nameError2' | translate}}</div>
                <div *ngIf="f.schName.errors?.maxlength" class="alert alert-danger">
                  {{'test.createSchedule.public.nameError3' | translate}}</div>
                <div *ngIf="f.schName.errors?.pattern" class="alert alert-danger">
                  {{'test.createSchedule.public.nameError4' | translate}}</div>
              </div>

            </div>
            <div class="form-group">
              <label for="Schedule description">{{'test.createSchedule.public.labelDesc' | translate}}</label>
              <textarea class="form-control" type="text" maxlength="481" id="schDescription" aria-describedby="scheduledescription" value=""
                name="schDescription" formControlName="schDescription"></textarea>
              <div *ngIf="f.schDescription.invalid && (f.schDescription.dirty || f.schDescription.touched )" class="alert alert-danger">
                <div *ngIf="f.schDescription.errors?.minlength">
                  {{'test.createSchedule.public.descError1' | translate}}</div>
                <div *ngIf="f.schDescription.errors?.maxlength">
                  {{'test.createSchedule.public.descError2' | translate}}</div>
              </div>
            </div>
            <div class="form-group details ptb-padding">
              <div class="filter-section title mb-margin"> <strong> {{'test.createSchedule.public.labelDetail' | translate}}</strong> </div>
              <label>{{'test.createSchedule.public.userParams' | translate}} <span class="red-asterisk">*</span></label>
              <br>
              <div class="">
                <mat-checkbox formControlName="AutoUniqueId" (change)="onSelectAutoGenerateUniqueID($event)">{{'test.createSchedule.public.autoUUID' | translate}}</mat-checkbox>
                <br><br>
              </div>

              <!-- <label for="">Add exa minne parameters*</label> -->
              <mat-form-field class="chip-list" *ngIf="!isParameterVisible">
                <!-- <span>{{'test.createSchedule.public.placeholder' | translate}}<span class="red-asterisk">*</span></span> -->
                <!-- <mat-label>{{'test.createSchedule.public.placeholder' | translate}}<span class="red-asterisk">*</span></mat-label> -->
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let examinee of chipSelectedExaminee" [selectable]=false>
                    {{examinee.fullName}}
                    <!-- <button class="btn-icon">
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </button> -->
                  </mat-chip>
                  <input placeholder="" required #examineeInput [formControl]="examineeControl" [matChipInputFor]="chipList" readonly
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]=true>
                </mat-chip-list>
              </mat-form-field>
              <div *ngIf="isExamineeExist && !isParameterVisible" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError1' | translate}}
              </div>
              <!-- <div *ngIf="isWrongExamineeValue" class="alert alert-danger">Examinee parameters is invalid! Only {{allowedExaminees.join(', ')}} are allowed.</div> -->
              <div *ngIf="isWrongExamineeValue || isMultipleSameExamineeValue && !isParameterVisible" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError2' | translate}}
              </div>
              <!--this validation no longer needed -->
              <!-- <div *ngIf="validateParam && !isParameterVisible" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError3' | translate}}
              </div> -->
              <!-- <div *ngIf="isMultipleSameExamineeValue" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError2' | translate}}
              </div> -->
            </div>

            <div class="row parameters" *ngIf="!isParameterVisible">
              <div class="col-lg-2 param" *ngFor="let param of createParamList">
                <mat-checkbox (change)="onSelectParam(param.key, $event)">{{param.value}}</mat-checkbox>
              </div>
            </div>

            <!-- <div class="row parameters" *ngIf="!isParameterVisible">
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('uuid', $event)">Unique ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('email', $event)">Email</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('fname', $event)">First name</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('lname', $event)">Last name</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('phone', $event)">Phone</mat-checkbox>
              </div>
            </div>

            <div class="row parameters" *ngIf="!isParameterVisible">
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('enrollmentid', $event)">Enrollment ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('assessmentid', $event)">Assessment ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('classid', $event)">Class ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('userid', $event)">User ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox (change)="onSelectParam('assignmentid', $event)">Assignment ID</mat-checkbox>
              </div>
              <br>
            </div> -->

            <div class="form-group date-n-time pb-padding pt-padding">
              <div class="row">
                <div class="col-md-2">
                  <div class="input-class">
                    <label for="">{{'test.createSchedule.public.dateAndTime.startDate' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-form-field class="example-full-width" appearance="fill">
                      <mat-label></mat-label>
                      <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="startDate" readonly/>
                      <!-- <input matInput [matDatepicker]="picker" formControlName="startDate"> -->
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>

                      <mat-datepicker #picker></mat-datepicker>

                    </mat-form-field>
                    <div *ngIf="f.startDate.invalid && ( f.startDate.touched || f.startDate.dirty )" class="alert alert-danger"> Start Date is invalid
                      <div *ngIf="f.startDate.errors?.required">Start Date is required
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-2 date-class">
                  <div class="input-time">
                    <label class="timepicker" for="">{{'test.createSchedule.public.dateAndTime.startTime' | translate}}<span class="red-asterisk">*</span></label>
                    <!-- <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'" formControlName="startTime">
                    </ngx-timepicker-field> -->
                    <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                      formControlName="startTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                    </ngx-timepicker-field>
                    <ng-template #cancelBtn>
                      <button class="clock">
                        {{'test.createSchedule.public.dateAndTime.btnCancel' | translate}} </button>
                    </ng-template>
                    <ng-template #okBtn>
                      <button class="clock">
                        {{'test.createSchedule.public.dateAndTime.btnOk' | translate}}</button>
                    </ng-template>

                    <div *ngIf="isStartTimeValid" class="alert alert-danger">
                      {{'test.createSchedule.public.dateAndTime.startTimeError1' | translate}}
                    </div>
                    <!-- <div *ngIf="f.startTime.invalid && (f.startTime.dirty || f.startTime.touched ) "
                                            class="alert alert-danger">
                                            <div *ngIf="f.startTime.errors?.required">Start Time is required</div>
                                        </div> -->
                  </div>
                </div>

                <div class="col-md-2 date-class">
                  <div class="input-class">
                    <label for="">{{'test.createSchedule.public.dateAndTime.endDate' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-form-field class="example-full-width" appearance="fill">
                      <!-- <mat-label>End date</mat-label> -->
                      <input matInput [matDatepicker]="picker1" [min]="minDate1" formControlName="endDate" readonly/>
                      <!-- <input matInput [matDatepicker]="picker1" formControlName="endDate"> -->
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="f.endDate.invalid && (f.endDate.dirty || f.endDate.touched )" class="alert alert-danger"> End Date is invalid
                      <div *ngIf="f.endDate.errors?.required">End Date is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 date-class">
                  <div class="input-time">
                    <label class="timepicker" for="">{{'test.createSchedule.public.dateAndTime.endTime' | translate}}<span class="red-asterisk">*</span></label>
                    <!-- <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" formControlName="endTime">
                    </ngx-timepicker-field> -->
                    <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                      formControlName="endTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                    </ngx-timepicker-field>
                    <ng-template #cancelBtn>
                      <button class="clock">
                        {{'test.createSchedule.public.dateAndTime.btnCancel' | translate}} </button>
                    </ng-template>
                    <ng-template #okBtn>
                      <button class="clock">
                        {{'test.createSchedule.public.dateAndTime.btnOk' | translate}}</button>
                    </ng-template>


                    <div *ngIf="isEndTimeValid" class="alert alert-danger">{{'test.createSchedule.public.dateAndTime.endTimeError1' | translate}}</div>

                    <!-- <div *ngIf="f.endTime.invalid && (f.endTime.dirty || f.endTime.touched )"
                                            class="alert alert-danger">
                                            <div *ngIf="f.endTime.errors?.required">End Time is required</div>
                                        </div> -->
                  </div>
                </div>
                <div class="col-md-3 date-class">
                  <div class="input-class">
                    <label class="timepicker" for="">{{'test.createSchedule.public.dateAndTime.timezone' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-select class="form-control timeZ" name="timezone" formControlName="timeZone" [value]="zone">
                      <mat-select-filter [array]="searchOptions" [displayMember]="'name'" (filteredReturn)="filteredList =$event" placeholder="{{'test.createSchedule.public.dateAndTime.inputSearch' | translate}}"></mat-select-filter>
                      <mat-option value="">
                        {{'test.createSchedule.public.dateAndTime.defaultTimezone' | translate}}</mat-option>
                      <mat-option *ngFor="let option of filteredList; let i = index" [value]="option.name">
                        {{option?.name}}
                      </mat-option>
                    </mat-select>
                    <div *ngIf="f.timeZone.invalid && (f.timeZone.dirty || f.timeZone.touched )" class="alert alert-danger">
                      <div *ngIf="f.timeZone.errors?.required">{{'test.createSchedule.public.dateAndTime.timezoneError1' | translate}}</div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group settings pb-padding">
              <div class="filter-section title"> <strong> {{'test.createSchedule.public.labelSetting' | translate}} </strong> </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.testScore' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput style-non" readonly formControlName="testTotalScore"><span>{{'test.createSchedule.public.inputSettings.labelmarks' | translate}}</span>
                  <div *ngIf="f.testTotalScore.invalid && (f.testTotalScore.dirty || f.testTotalScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testTotalScore.errors?.required">{{'test.createSchedule.public.inputSettings.testScoreError1' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.labelQuestMandotry' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="iallquestionsmandatory">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.testDuration' | translate}}<span class="red-asterisk">*</span></label>

                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testDuration" min="0" max="9999"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"><span>{{'test.createSchedule.public.inputSettings.labelmin' | translate}}</span>
                  <div *ngIf="f.testDuration.invalid && (f.testDuration.dirty || f.testDuration.touched )" class="alert alert-danger">
                    <div *ngIf="f.testDuration.errors?.required">
                      {{'test.createSchedule.public.inputSettings.testDurationError1' | translate}}
                    </div>
                    <div *ngIf="f.testDuration.errors?.pattern">
                      {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                    </div>
                  </div>

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showToolSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showTools">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.testPass' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testPassingScore" min="0" (keyup)="testScoreChange()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999"><span>{{'test.createSchedule.public.inputSettings.labelmarks' | translate}}</span>

                  <div *ngIf="f.testPassingScore.invalid && (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testPassingScore.errors?.required">
                      {{'test.createSchedule.public.inputSettings.testPassError1' | translate}}
                    </div>
                    <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                      {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                    </div> -->
                  </div>
                  <!-- <div *ngIf="f.testPassingScore.invalid && (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testPassingScore.errors?.required">{{'test.createSchedule.public.inputSettings.testPassError1' | translate}}</div>
                    <div *ngIf="f.testPassingScore.errors?.pattern">{{'test.createSchedule.public.inputSettings.testPassError2' | translate}}</div>
                  </div> -->
                  <!-- <div *ngIf="setTestScoremsg" class="alert alert-danger">
                    <div>{{'test.createSchedule.public.inputSettings.testPassError3' | translate}}</div>
                  </div> -->
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showItemListSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showItemList">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.testPenalty' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="penaltyPoints" min="0" (keyup)="checkTestValue()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999"><span>{{'test.createSchedule.public.inputSettings.labelmarks' | translate}}</span>

                  <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty || f.penaltyPoints.touched )" class="alert alert-danger">
                    <div *ngIf="f.penaltyPoints.errors?.required">
                      {{'test.createSchedule.public.inputSettings.penaltyError1' | translate}}
                    </div>
                    <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                      {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                    </div> -->
                  </div>

                  <!-- <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty || f.penaltyPoints.touched )" class="alert alert-danger">
                    <div *ngIf="f.penaltyPoints.errors?.required">{{'test.createSchedule.public.inputSettings.penaltyError1' | translate}}</div>
                    <div *ngIf="publicScheduleForm.controls.penaltyPoints.value<0">{{'test.createSchedule.public.inputSettings.penaltyError2' | translate}}</div>
                  </div>
                  <div *ngIf="setPenaltymsg" class="alert alert-danger">
                    <div>{{'test.createSchedule.public.inputSettings.penaltyError3' | translate}}</div>
                  </div> -->

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.maxNumberofAttempts' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1">
                  <div class="maxAttempts">
                    <select class="form-control" [(ngModel)]="maxAttempts" (change)="onSelectMaxAttempts($event)" formControlName="MaxAttempts">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2"></div>
                <!-- <div class="col-md-8">
                                 /   <div class="switch-op">
                                        <label for="">Shuffle questions</label>
                                        <mat-slide-toggle formControlName="shuffleQuestions">
                                        </mat-slide-toggle>

                                    </div>
                                    <div class="switch-op">
                                        <label for="">Shuffle options</label>
                                        <mat-slide-toggle formControlName="shuffleOptions">
                                        </mat-slide-toggle>

                                    </div>


                                </div> -->

              </div>

              <div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-2" *ngIf="isAllowAttempts">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.allowAttemptsAfter' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="weeks" formControlName="Weeks">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.weeks' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="days" formControlName="days">
                      <option value="{{i}}" *ngFor='let in of counter(31) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.days' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="hours" formControlName="hours">
                      <option value="{{i}}" *ngFor='let in of counter(24) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.hours' | translate}}</label>
                  </div>
                </div>
              </div>

            </div>

            <div class="messages pb-padding">
              <div class="title" id="mrg-bottom"> <strong> {{'test.createSchedule.public.labelMsg' | translate}} </strong> </div>
              <div class="filter-section"> <label>{{'test.createSchedule.public.labelPreTest' | translate}}<span class="red-asterisk">*</span></label></div>
              <div class="row">
                <div class="col-md-12 editor-cls">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.createSchedule.public.placeholderEnter' | translate" class="form-control textarea" [editor]="editor"
                    formControlName="preMessageText">
                  </ngx-editor>
                  <div *ngIf="f.preMessageText.invalid && (f.preMessageText.dirty || f.preMessageText.touched )" class="alert alert-danger">
                    <!-- <div *ngIf="f.preMessageText?.errors?.required">Message is required</div> -->
                    <div *ngIf="f.preMessageText?.errors?.minlength">{{'test.createSchedule.public.preTestError1' | translate}}</div>
                    <div *ngIf="f.preMessageText?.errors?.maxlength">{{'test.createSchedule.public.preTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="filter-section post-wrapper"><label>{{'test.createSchedule.public.labelPostTest' | translate}}<span class="red-asterisk">*</span> </label></div>
              <div class="row" class="'mrg-top-msg">
                <div class=" editor-cls">
                  <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.createSchedule.public.placeholderEnter' | translate" class="form-control" [editor]="editor1" maxLength="1001"
                    formControlName="postMessageText">
                  </ngx-editor>
                  <div *ngIf="f.postMessageText.invalid && (f.postMessageText.dirty || f.postMessageText.touched )" class="alert alert-danger">
                    <!-- <div *ngIf="f.postMessageText?.errors?.required">Message is required</div> -->
                    <div *ngIf="f.postMessageText?.errors?.minlength">{{'test.createSchedule.public.postTestError1' | translate}}</div>
                    <div *ngIf="f.postMessageText?.errors?.maxlength">{{'test.createSchedule.public.postTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
